import Estimations, {
    ArticleEstimation,
    getArticlesEstimations,
    getEstimationForMonthArticleAndSku,
    ItemEstimation,
    MonthEstimation
} from './Estimations';

export default (estimations: Estimations, placedEstimations: Estimations): boolean => {
    return (
        areItemsChanged(estimations, placedEstimations) ||
        estimations.some((estimation: MonthEstimation) => {
            return estimation.articlesEstimations.some((articleEstimation: ArticleEstimation) => {
                return articleEstimation.itemsEstimations.some(
                    (a: ItemEstimation) =>
                        getEstimationForMonthArticleAndSku(placedEstimations, articleEstimation.articleId, a.sku, estimation.month) !==
                        a.value
                );
            });
        })
    );
};

const isAnyEstimationRemoved = (estimations: Estimations, placedEstimations: Estimations): boolean =>
    placedEstimations.some((placedEstimation: MonthEstimation) => {
        const estimationFromMonth: ArticleEstimation[] = getArticlesEstimations(estimations, placedEstimation.month);
        if (estimationFromMonth.length > 0) {
            return placedEstimation.articlesEstimations.some((placedArticleEstimation: ArticleEstimation) => {
                const estimatedItems: ArticleEstimation | undefined = estimationFromMonth.find(
                    (articleEstimation: ArticleEstimation) => articleEstimation.articleId === placedArticleEstimation.articleId
                );
                if (estimatedItems !== undefined) {
                    return placedArticleEstimation.itemsEstimations.length > estimatedItems.itemsEstimations.length;
                } else {
                    return placedArticleEstimation.itemsEstimations.length > 0;
                }
            });
        } else {
            return placedEstimation.articlesEstimations.length > 0;
        }
    });

const isAnyMonthWithEstimation = (estimations: Estimations): boolean =>
    estimations.some((estimation: MonthEstimation) => {
        return estimation.articlesEstimations.length > 0;
    });

const areItemsChanged = (estimations: Estimations, placedEstimations: Estimations): boolean => {
    return isAnyEstimationRemoved(estimations, placedEstimations) && isAnyMonthWithEstimation(estimations);
};



// WEBPACK FOOTER //
// ./src/domain/estimations/containsAtLeastOneNotSavedEstimation.ts